import React from 'react';

const Progress = () => (
    <div id="progress">
        <div className="bar" />
    </div>
);

export default Progress;
